<template>
    <v-container fluid>
        <template v-if="response">
            <v-card class="mb-5 pa-2">
                <card-header title="Sincronização de clientes"></card-header>
                <v-card-text>
                    <div>{{ response.message }}</div>
                </v-card-text>
            </v-card>
        </template>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
export default {
    props: ['id'],

    data: () => {
        return {
            response: null,
        }
    },

    methods: {
        async sendToSync() {
            let res = await this.$http.get(
                this.id ? 'sync-customers/' + this.id : 'sync-customers',
            )

            this.response = res.data

            console.log(this.response, res)
        },
    },

    created() {
        this.sendToSync()
    },
}
</script>
